import ProjectImg1 from "../assets/img/projects/carpet1.jpg";
import ProjectImg2 from "../assets/img/projects/carpet2.jpg";
import ProjectImg3 from "../assets/img/projects/carpet3.jpg";
import ProjectImg4 from "../assets/img/projects/carpet4.jpg";
import ProjectImg5 from "../assets/img/projects/carpet5.jpg";
import ProjectImg6 from "../assets/img/projects/carpet6.jpg";

export const sizes = [
  "96x60",
  "120x65",
  "100x150",
  "150x200",
  "70x200",
  "70x250",
  "80x300",
  "160x260",
  "200x200",
  "200x300",
  "250x300",
  "300x400",
];


export const models = [
  "Klassisch",
  "Modern",
  "Seide",
  "Kelim",
  "Ausgewählte",
  "Läufer",
  "Dekokisse"
];

export const colors = [
  "Rot",
  "Blau",
  "Beige",
  "Grau",
  "Grün",
  "Mehrfarbig"
];

export const materials = [
  "Wollteppich – langlebig, weich, natürlich isolierend",
  "Baumwollteppich – leicht, pflegeleicht, meist flachgewebt",
  "Seidenteppich – luxuriös, glänzend, feine Muster",
  "Synthetikteppich (Polypropylen, Polyester, Nylon) – günstig, strapazierfähig",
  "Juteteppich – nachhaltig, rustikaler Look",
  "Sisal-Teppich – robust, ideal für Flure",
  "Lederteppich – ausgefallen, modern",
  "Viskose-Teppich – weich, glänzend, empfindlich"
];

export const manufacturing = [
  "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide",
  "Handgetufteter Teppich – weicher Flor, schneller hergestellt als geknüpfte Teppiche",
  "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich",
  "Flachgewebter Teppich (Kelims, Dhurries) – dünn, oft beidseitig nutzbar",
  "Berberteppich – dick, flauschig, aus Schafwolle"
];

export const designs = [
  "Orientteppich – traditionelle Muster aus Persien, Türkei, Indien",
  "Moderne Teppiche – abstrakte Muster, minimalistisch",
  "Vintage-Teppiche – künstlich gealtert, Used-Look",
  "Boho-Teppiche – bunt, verspielte Muster",
  "Patchwork-Teppiche – zusammengesetzt aus verschiedenen Stücken",
  "Skandinavische Teppiche – helle Farben, schlichte Muster"
];

export const usage = [
  "Wohnzimmerteppich – meist groß, dekorativ",
  "Läufer – schmal, für Flure oder Küchen",
  "Kinderteppich – bunt, spielerisch, weich",
  "Outdoor-Teppich – wetterfest, für Balkone/Terrassen",
  "Badezimmerteppich – rutschfest, wasserabweisend",
  "Flauschteppich / Hochflorteppich – besonders weich, kuschelig"
];
export const carpets = [
  {
    id: "1",
    name: "Orientalischer Klassiker",
    model: "Perserteppich",
    size: "200x300 cm",
    color: "Rot",
    material: "Wollteppich – langlebig, weich, natürlich isolierend",
    manufacturing: "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide",
    design: "Orientteppich – traditionelle Muster aus Persien, Türkei, Indien",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "199.99",
    shortDescription: "Ein handgeknüpfter orientalischer Teppich mit traditionellen Mustern.",
    detailedDescription: "Dieser orientalische Teppich wird in feinster Handarbeit gefertigt. Seine einzigartigen Muster und kräftigen Farben machen ihn zum perfekten Highlight für jedes Wohnzimmer.",
    images: [ProjectImg1, ProjectImg2, ProjectImg3],
    created_time: "2024-01-10T10:00:00Z",
    updated_time: "2024-02-15T12:30:00Z",
    updated_by: "Admin",
    tags: ["Perserteppich", "Rot", "Wollteppich – langlebig, weich, natürlich isolierend", "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide", "Orientteppich – traditionelle Muster aus Persien, Türkei, Indien", "Wohnzimmerteppich – meist groß, dekorativ"]
  },
  {
    id: "2",
    name: "Modern Chic",
    model: "Moderne Teppiche",
    size: "160x230 cm",
    color: "Grau",
    material: "Synthetikteppich (Polypropylen, Polyester, Nylon) – günstig, strapazierfähig",
    manufacturing: "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich",
    design: "Moderne Teppiche – abstrakte Muster, minimalistisch",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "149.99",
    shortDescription: "Ein moderner Teppich für ein zeitgemäßes Wohnambiente.",
    detailedDescription: "Der 'Modern Chic' Teppich vereint stilvolles Design mit hochwertiger Verarbeitung. Seine dezente Farbkombination passt perfekt zu modernen Innenräumen und sorgt für eine angenehme Atmosphäre.",
    images: [ProjectImg2, ProjectImg4],
    created_time: "2024-02-01T09:15:00Z",
    updated_time: "2024-02-20T14:45:00Z",
    updated_by: "Moderator",
    tags: ["Moderne Teppiche", "Grau", "Synthetikteppich (Polypropylen, Polyester, Nylon) – günstig, strapazierfähig", "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich", "Wohnzimmerteppich – meist groß, dekorativ"]
  },
  {
    id: "3",
    name: "Vintage Eleganz",
    model: "Vintage-Teppiche",
    size: "160x230 cm",
    color: "Beige",
    material: "Baumwollteppich – leicht, pflegeleicht, meist flachgewebt",
    manufacturing: "Handgetufteter Teppich – weicher Flor, schneller hergestellt als geknüpfte Teppiche",
    design: "Vintage-Teppiche – künstlich gealtert, Used-Look",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "129.99",
    shortDescription: "Ein stilvoller Vintage-Teppich mit nostalgischem Charme.",
    detailedDescription: "Dieser Vintage-Teppich bringt einen Hauch von Eleganz in jedes Zuhause. Er ist strapazierfähig und pflegeleicht.",
    images: [ProjectImg3, ProjectImg5],
    created_time: "2024-02-10T08:30:00Z",
    updated_time: "2024-02-18T16:10:00Z",
    updated_by: "Admin",
    tags: ["Vintage-Teppiche", "Beige", "Baumwollteppich – leicht, pflegeleicht, meist flachgewebt", "Handgetufteter Teppich – weicher Flor, schneller hergestellt als geknüpfte Teppiche", "Wohnzimmerteppich – meist groß, dekorativ"]
  },
  {
    id: "4",
    name: "Shaggy Komfort",
    model: "Flauschteppich / Hochflorteppich",
    size: "220x300 cm",
    color: "Beige",
    material: "Wollteppich – langlebig, weich, natürlich isolierend",
    manufacturing: "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide",
    design: "Moderne Teppiche – abstrakte Muster, minimalistisch",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "179.99",
    shortDescription: "Extra weich für höchsten Komfort im Wohnzimmer.",
    detailedDescription: "Der 'Shaggy Komfort' Teppich bietet eine besonders weiche Oberfläche für ein angenehmes Laufgefühl.",
    images: [ProjectImg5, ProjectImg1],
    created_time: "2024-01-20T07:45:00Z",
    updated_time: "2024-02-22T10:55:00Z",
    updated_by: "Admin",
    tags: ["Flauschteppich / Hochflorteppich", "Beige", "Wollteppich – langlebig, weich, natürlich isolierend", "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide", "Wohnzimmerteppich – meist groß, dekorativ"]
  },
  {
    id: "5",
    name: "Outdoor Teppich Robust",
    model: "Outdoor-Teppich",
    size: "200x300 cm",
    color: "Blau",
    material: "Synthetikteppich (Polypropylen, Polyester, Nylon) – günstig, strapazierfähig",
    manufacturing: "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich",
    design: "Moderne Teppiche – abstrakte Muster, minimalistisch",
    usage: "Outdoor-Teppich – wetterfest, für Balkone/Terrassen",
    price: "129.99",
    shortDescription: "Wetterfester Teppich für den Außenbereich.",
    detailedDescription: "Dieser Outdoor-Teppich ist ideal für Balkone und Terrassen. Er ist wetterfest, pflegeleicht und langlebig.",
    images: [ProjectImg6, ProjectImg4],
    created_time: "2024-03-01T11:00:00Z",
    updated_time: "2024-03-05T15:20:00Z",
    updated_by: "Admin",
    tags: ["Outdoor-Teppich – wetterfest, für Balkone/Terrassen", "Blau", "Synthetikteppich (Polypropylen, Polyester, Nylon) – günstig, strapazierfähig", "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich"]
  },
  {
    id: "6",
    name: "Boho Chic",
    model: "Boho-Teppiche",
    size: "140x200 cm",
    color: "Mehrfarbig",
    material: "Baumwollteppich – leicht, pflegeleicht, meist flachgewebt",
    manufacturing: "Flachgewebter Teppich (Kelims, Dhurries) – dünn, oft beidseitig nutzbar",
    design: "Boho-Teppiche – bunt, verspielte Muster",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "99.99",
    shortDescription: "Farbenfroher Boho-Teppich für ein gemütliches Zuhause.",
    detailedDescription: "Dieser Boho-Teppich bringt Farbe und Leben in dein Wohnzimmer mit seinen kreativen Mustern und verspielten Designs.",
    images: [ProjectImg1, ProjectImg3],
    created_time: "2024-02-05T10:30:00Z",
    updated_time: "2024-03-02T15:50:00Z",
    updated_by: "Moderator",
    tags: ["Boho-Teppiche – bunt, verspielte Muster", "Mehrfarbig", "Baumwollteppich – leicht, pflegeleicht, meist flachgewebt", "Flachgewebter Teppich (Kelims, Dhurries) – dünn, oft beidseitig nutzbar"]
  },
  {
    id: "7",
    name: "Patchwork Exklusiv",
    model: "Patchwork-Teppiche",
    size: "160x230 cm",
    color: "Mehrfarbig",
    material: "Wollteppich – langlebig, weich, natürlich isolierend",
    manufacturing: "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide",
    design: "Patchwork-Teppiche – zusammengesetzt aus verschiedenen Stücken",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "189.99",
    shortDescription: "Einzigartiger Patchwork-Teppich mit traditionellem Touch.",
    detailedDescription: "Der Patchwork-Teppich vereint verschiedene Stile in einem und sorgt für einen individuellen Look im Wohnbereich.",
    images: [ProjectImg2, ProjectImg4],
    created_time: "2024-02-10T12:15:00Z",
    updated_time: "2024-03-07T14:20:00Z",
    updated_by: "Admin",
    tags: ["Patchwork-Teppiche – zusammengesetzt aus verschiedenen Stücken", "Mehrfarbig", "Wollteppich – langlebig, weich, natürlich isolierend", "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide"]
  },
  {
    id: "8",
    name: "Scandi Minimal",
    model: "Skandinavische Teppiche",
    size: "200x300 cm",
    color: "Beige",
    material: "Viskose-Teppich – weich, glänzend, empfindlich",
    manufacturing: "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich",
    design: "Skandinavische Teppiche – helle Farben, schlichte Muster",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "159.99",
    shortDescription: "Minimalistischer Teppich für modernes Wohnen.",
    detailedDescription: "Dieser skandinavische Teppich bringt Schlichtheit und Eleganz in jedes Zuhause mit seinen hellen Farben und minimalistischen Designs.",
    images: [ProjectImg5, ProjectImg6],
    created_time: "2024-02-15T09:00:00Z",
    updated_time: "2024-03-10T16:40:00Z",
    updated_by: "Moderator",
    tags: ["Skandinavische Teppiche – helle Farben, schlichte Muster", "Beige", "Viskose-Teppich – weich, glänzend, empfindlich", "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich"]
  },
  {
    id: "9",
    name: "Luxus Seide",
    model: "Seidenteppich",
    size: "160x230 cm",
    color: "Blau",
    material: "Seidenteppich – luxuriös, glänzend, feine Muster",
    manufacturing: "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide",
    design: "Orientteppich – traditionelle Muster aus Persien, Türkei, Indien",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "499.99",
    shortDescription: "Hochwertiger Seidenteppich mit exquisitem Glanz.",
    detailedDescription: "Dieser edle Seidenteppich verleiht jedem Raum eine luxuriöse Ausstrahlung und ist ein echtes Highlight für Ihr Zuhause.",
    images: [ProjectImg1, ProjectImg3],
    created_time: "2024-02-20T11:30:00Z",
    updated_time: "2024-03-12T12:55:00Z",
    updated_by: "Admin",
    tags: ["Seidenteppich – luxuriös, glänzend, feine Muster", "Blau", "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide", "Orientteppich – traditionelle Muster aus Persien, Türkei, Indien"]
  },
  {
    id: "10",
    name: "Berber Traum",
    model: "Berberteppich",
    size: "200x300 cm",
    color: "Weiß",
    material: "Wollteppich – langlebig, weich, natürlich isolierend",
    manufacturing: "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide",
    design: "Berberteppich – dick, flauschig, aus Schafwolle",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "219.99",
    shortDescription: "Kuscheliger Berberteppich aus reiner Schafwolle.",
    detailedDescription: "Ein traditioneller Berberteppich mit dichtem Flor und außergewöhnlicher Weichheit. Perfekt für ein gemütliches Wohnzimmer.",
    images: [ProjectImg4, ProjectImg6],
    created_time: "2024-02-25T13:00:00Z",
    updated_time: "2024-03-14T09:45:00Z",
    updated_by: "Moderator",
    tags: ["Berberteppich – dick, flauschig, aus Schafwolle", "Weiß", "Wollteppich – langlebig, weich, natürlich isolierend", "Handgeknüpfter Teppich – hochwertig, traditionell, meist aus Wolle oder Seide"]
  },
  {
    id: "11",
    name: "Leder Look",
    model: "Lederteppich",
    size: "140x200 cm",
    color: "Braun",
    material: "Lederteppich – ausgefallen, modern",
    manufacturing: "Handgetufteter Teppich – weicher Flor, schneller hergestellt als geknüpfte Teppiche",
    design: "Moderne Teppiche – abstrakte Muster, minimalistisch",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "289.99",
    shortDescription: "Ein moderner Teppich aus echtem Leder.",
    detailedDescription: "Einzigartiger Lederteppich mit modernem Design. Hochwertige Verarbeitung und angenehmes Gefühl unter den Füßen.",
    images: [ProjectImg2, ProjectImg5],
    created_time: "2024-02-28T10:15:00Z",
    updated_time: "2024-03-16T12:30:00Z",
    updated_by: "Admin",
    tags: ["Lederteppich – ausgefallen, modern", "Braun", "Handgetufteter Teppich – weicher Flor, schneller hergestellt als geknüpfte Teppiche", "Moderne Teppiche – abstrakte Muster, minimalistisch"]
  },
  {
    id: "12",
    name: "Natur Jute",
    model: "Juteteppich",
    size: "180x250 cm",
    color: "Natur",
    material: "Juteteppich – nachhaltig, rustikaler Look",
    manufacturing: "Flachgewebter Teppich (Kelims, Dhurries) – dünn, oft beidseitig nutzbar",
    design: "Boho-Teppiche – bunt, verspielte Muster",
    usage: "Wohnzimmerteppich – meist groß, dekorativ",
    price: "129.99",
    shortDescription: "Rustikaler Juteteppich für einen natürlichen Wohnstil.",
    detailedDescription: "Ein nachhaltiger Teppich aus Jute mit einem modernen, rustikalen Look. Ideal für ein naturverbundenes Ambiente.",
    images: [ProjectImg1, ProjectImg3],
    created_time: "2024-03-03T11:45:00Z",
    updated_time: "2024-03-18T14:20:00Z",
    updated_by: "Moderator",
    tags: ["Juteteppich – nachhaltig, rustikaler Look", "Natur", "Flachgewebter Teppich (Kelims, Dhurries) – dünn, oft beidseitig nutzbar", "Boho-Teppiche – bunt, verspielte Muster"]
  },
  {
    id: "13",
    name: "Sisal Eleganz",
    model: "Sisal-Teppich",
    size: "200x300 cm",
    color: "Beige",
    material: "Sisal-Teppich – robust, ideal für Flure",
    manufacturing: "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich",
    design: "Skandinavische Teppiche – helle Farben, schlichte Muster",
    usage: "Läufer – schmal, für Flure oder Küchen",
    price: "179.99",
    shortDescription: "Strapazierfähiger Sisal-Teppich für Flure oder Küchen.",
    detailedDescription: "Ein robuster Sisal-Teppich, der sich ideal für stark frequentierte Bereiche wie Flure oder Küchen eignet.",
    images: [ProjectImg2, ProjectImg4],
    created_time: "2024-03-06T14:00:00Z",
    updated_time: "2024-03-20T16:30:00Z",
    updated_by: "Admin",
    tags: ["Sisal-Teppich – robust, ideal für Flure", "Beige", "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich", "Läufer – schmal, für Flure oder Küchen"]
  },
  {
    id: "14",
    name: "Kinderzauber",
    model: "Kinderteppich",
    size: "140x200 cm",
    color: "Bunt",
    material: "Baumwollteppich – leicht, pflegeleicht, meist flachgewebt",
    manufacturing: "Handgetufteter Teppich – weicher Flor, schneller hergestellt als geknüpfte Teppiche",
    design: "Boho-Teppiche – bunt, verspielte Muster",
    usage: "Kinderteppich – bunt, spielerisch, weich",
    price: "99.99",
    shortDescription: "Ein weicher und spielerischer Teppich für Kinderzimmer.",
    detailedDescription: "Dieser farbenfrohe Kinderteppich ist rutschfest und aus weicher Baumwolle gefertigt. Ideal für Spielspaß und Komfort.",
    images: [ProjectImg5, ProjectImg6],
    created_time: "2024-03-08T09:30:00Z",
    updated_time: "2024-03-22T10:45:00Z",
    updated_by: "Moderator",
    tags: ["Kinderteppich – bunt, spielerisch, weich", "Bunt", "Baumwollteppich – leicht, pflegeleicht, meist flachgewebt", "Handgetufteter Teppich – weicher Flor, schneller hergestellt als geknüpfte Teppiche"]
  },
  {
    id: "15",
    name: "Outdoor Fest",
    model: "Outdoor-Teppich",
    size: "180x250 cm",
    color: "Grau",
    material: "Synthetikteppich (Polypropylen, Polyester, Nylon) – günstig, strapazierfähig",
    manufacturing: "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich",
    design: "Moderne Teppiche – abstrakte Muster, minimalistisch",
    usage: "Outdoor-Teppich – wetterfest, für Balkone/Terrassen",
    price: "139.99",
    shortDescription: "Wetterfester Outdoor-Teppich für Balkon und Terrasse.",
    detailedDescription: "Ein strapazierfähiger, pflegeleichter Outdoor-Teppich mit modernem Design, perfekt für den Außenbereich.",
    images: [ProjectImg1, ProjectImg3],
    created_time: "2024-03-10T15:20:00Z",
    updated_time: "2024-03-25T12:10:00Z",
    updated_by: "Admin",
    tags: ["Outdoor-Teppich – wetterfest, für Balkone/Terrassen", "Grau", "Synthetikteppich (Polypropylen, Polyester, Nylon) – günstig, strapazierfähig", "Maschinell gewebter Teppich – preiswert, in großer Vielfalt erhältlich"]
  },
];
